import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * delivery veb-marshrutlari (W: /w/delivery/*) — modul layout (gorizontal sub-nav) ichida bo'limlar.
 * Hamkor portalida alohida bo'lim yo'q (buyurtma kartasida oms yetkazish holatini ko'rsatadi).
 */
export const workRoutes: RouteObject[] = [
  {
    path: 'delivery',
    ...page(() => import('./components/DeliveryLayout')),
    children: [
      { index: true, ...page(() => import('./pages/TasksPage')) },
      { path: 'receive', ...page(() => import('./pages/ReceivePage')) },
      { path: 'days', ...page(() => import('./pages/DaysPage')) },
      { path: 'days/:id', ...page(() => import('./pages/DayDetailPage')) },
      { path: 'returns', ...page(() => import('./pages/ReturnsPage')) },
      { path: 'requests', ...page(() => import('./pages/RequestsPage')) },
      { path: 'settlement', ...page(() => import('./pages/SettlementPage')) },
      { path: 'couriers', ...page(() => import('./pages/CouriersPage')) },
      { path: 'settings', ...page(() => import('./pages/SettingsPage')) },
      { path: 'reports', ...page(() => import('./pages/ReportsPage')) },
      { path: 'me', ...page(() => import('./pages/MyDayPage')) },
    ],
  },
];

export const sellerRoutes: RouteObject[] = [];
